export default {
    postObj(ClassName,FunctionaCall){
        return {
            "__class":ClassName, 
            "__call":FunctionaCall
          }
    }
}